module.exports = __webpack_public_path__ + "static/img/brand8.c3e4b4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/brand/brand8.png
// module id = hlke
// module chunks = 1